import { ChangeEvent } from "react";
import { RequiredManager } from "../../../shared/RequieredManager";
import { CriterionModel } from "../../providers/CriteriaContext";
import Dropdown from "../../../shared/components/Dropdown";
import { InputWithValidation } from "./InputWithValidation";

type NumberAmountCriterionProps = {
  data: CriterionModel;
  criterionIsNumber: boolean;
  criterionId: number;
  amountOperators: any[];
  currencySymbol: string;
  inputResetKey: number;
  onOperatorChange: (value: number) => void;
  onValueChange: (e: ChangeEvent<HTMLInputElement>) => void;
  requiredManager: RequiredManager;
};

export const NumberAmountCriterion = ({
  data,
  criterionIsNumber,
  criterionId,
  amountOperators,
  currencySymbol,
  inputResetKey,
  onOperatorChange,
  onValueChange,
  requiredManager
}: NumberAmountCriterionProps) => {
  const getBoxText = () => {
    if (criterionId === 31) return "%";
    return currencySymbol;
  };

  return (
    <>
      <Dropdown
        selectClasses=""
        onChange={onOperatorChange}
        items={amountOperators}
        defaultValue={data.Operator}
      />
      <InputWithValidation
        inputResetKey={inputResetKey}
        type="number"
        item={data}
        filterKey="Value"
        callback={onValueChange}
        requiredManager={requiredManager}
        boxLeft={true}
        withBox={!criterionIsNumber}
        boxText={getBoxText()}
      />
    </>
  );
};
